import Link from 'next/link';
import clsx from 'clsx';

import useI18n from '@i18n';

import ContainerWithLayout from '../Base/ContainerWithLayout';
import SectionTitle from '../Base/SectionTitle';
import ForWhomBlock from './ForWhomBlock';

import arbitrageImg from './img/arbitrage.png';
import blogersImg from './img/blogers.png';
import cashbackImg from './img/cashback.png';
import messengersImg from './img/messengers.png';
import webmastersImg from './img/webmasters.png';

import styles from './ForWhom.module.scss';

const BlockForWhom: React.FC = () => {
    const { t, locale } = useI18n('Landing');
    return (
        <section className={styles.forWhom}>
            <ContainerWithLayout colorName="grey">
                <div className={clsx(styles.landingContainer, styles.forWhom_content)}>
                    <div className={styles.forWhom_header}>
                        <SectionTitle classname={styles.forWhom_header_title} bigger>
                            {t('Who is this for?')}
                        </SectionTitle>
                        <ForWhomBlock
                            classname={styles.forWhom_header_card}
                            imgSrc={webmastersImg}
                            text={
                                <>
                                    <Link
                                        href={`/${locale}/offers?trafficSources=10&typeId=1,2,6,7&order=webmasterPriority`}
                                        className="underline"
                                        target="_blank"
                                    >
                                        {t('Owners of websites')}
                                    </Link>{' '}
                                    {t('price comparison services, affiliate stores')}
                                </>
                            }
                        />
                    </div>
                    <div className={styles.forWhom_list}>
                        <ForWhomBlock
                            imgSrc={webmastersImg}
                            text={
                                <>
                                    <Link
                                        href={`/${locale}/offers?trafficSources=10&typeId=1,2,6,7&order=webmasterPriority`}
                                        className="underline"
                                        target="_blank"
                                    >
                                        {t('Owners of websites')}
                                    </Link>{' '}
                                    {t('price comparison services, affiliate stores')}
                                </>
                            }
                        />
                        <ForWhomBlock
                            imgSrc={arbitrageImg}
                            text={
                                <>
                                    <Link
                                        href={`/${locale}/offers?trafficSources=24&typeId=1,2,6,7&order=webmasterPriority`}
                                        className="underline"
                                        target="_blank"
                                    >
                                        {t('Affiliate marketers')}
                                    </Link>{' '}
                                    {t(
                                        'who work with PPC (pay-per-click) and social media advertising',
                                    )}
                                </>
                            }
                        />
                        <ForWhomBlock
                            imgSrc={blogersImg}
                            text={
                                <>
                                    {t('Beginners and experienced')}
                                    <Link
                                        href={`/${locale}/offers?trafficSources=28&typeId=1,2,6,7&order=webmasterPriority`}
                                        className="underline"
                                        target="_blank"
                                    >
                                        {t('bloggers')}
                                    </Link>{' '}
                                    {t('and')}{' '}
                                    <Link
                                        href={`/${locale}/offers?trafficSources=22&typeId=1,2,6,7&order=webmasterPriority`}
                                        className="underline"
                                        target="_blank"
                                    >
                                        {t('video bloggers')}
                                    </Link>
                                </>
                            }
                        />
                        <ForWhomBlock
                            imgSrc={cashbackImg}
                            text={
                                <>
                                    <Link
                                        href={`/${locale}/offers?trafficSources=14&typeId=1,2,6,7&order=webmasterPriority`}
                                        className="underline"
                                        target="_blank"
                                    >
                                        {t('Cashback services')}
                                    </Link>{' '}
                                    {t('and loyalty programs')}
                                </>
                            }
                        />
                        <ForWhomBlock
                            imgSrc={messengersImg}
                            text={
                                <>
                                    {t('Users and owners')}{' '}
                                    <Link
                                        href={`/${locale}/offers?trafficSources=6&typeId=1,2,6,7&order=webmasterPriority`}
                                        className="underline"
                                        target="_blank"
                                    >
                                        {t('of social media groups')}
                                    </Link>{' '}
                                    <Link
                                        href={`/${locale}/offers?trafficSources=26&typeId=1,2,6,7&order=webmasterPriority`}
                                        className="underline"
                                        target="_blank"
                                    >
                                        {t('channels in messaging apps')}
                                    </Link>
                                </>
                            }
                        />
                    </div>
                </div>
            </ContainerWithLayout>
        </section>
    );
};

export default BlockForWhom;
